































import { Component, Vue } from 'vue-property-decorator';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import { DataTableState, TableContext } from '@/typings/datatable';

import DataTableWithFilters, { DataTableFilter } from '@/components/datatable-filters.vue';

import { FormulasApi, Formula } from '../../../../../api';
import { ApiUtils, FilterParam } from '@/common/ApiUtils';
import RouterLinkButton from '@/components/elements/buttons/router-link-button.vue';

@Component({
	components: {
		RouterLinkButton,
		secondaryNav,
		DataTableWithFilters,
	},
})
export default class FormulasList extends Vue {
	public state: DataTableState = {
		fields: [
			{ key: 'id', sortable: true },
			{ key: 'name', label: 'Formula Name', sortable: true },
			{ key: 'sensorType', label: 'Sensor Type', sortable: true },
			{ key: 'entityType', label: 'Entity Type', sortable: true },
			{ key: 'usedBy', label: 'Used By', sortable: false },
			{
				key: 'archived',
				label: 'Archived',
				sortable: true,
				formatter: (archived: boolean) => (archived ? 'Yes' : 'No'),
			},
		],
		loading: false,
		search: null,
		sortBy: 'name,archived',
		primaryKey: 'id',
		sortDesc: false,
		perPage: 20,
		currentPage: 1,
		totalRows: 0,
	};

	public filters: DataTableFilter[] = [
		{
			label: 'Sensor Type',
			field: 'sensorType',
			value: [],
			type: 'checkboxes',
			options: [
				{ text: 'Capacitance', value: 'capacitance' },
				{ text: 'Distance', value: 'distance' },
				{ text: 'Radar Distance', value: 'radarDistance' },
			],
		},
		{
			label: 'Entity Type',
			field: 'entityType',
			value: [],
			type: 'checkboxes',
			options: [
				{ text: 'Fuel Tanks', value: 'tanks' },
				{ text: 'Milk Vats', value: 'vats' },
				{ text: 'Feed Tanks', value: 'feed_tanks' },
			],
		},
		{
			label: 'Status',
			field: 'archived',
			value: [],
			type: 'checkboxes',
			options: [{ text: 'Archived', value: true }],
		},
	];

	private api: FormulasApi;

	constructor() {
		super();
		this.api = new FormulasApi();
	}

	public reload() {
		this.$root.$emit('bv::refresh::table', 'site-datatable');
	}

	public click(item: Formula) {
		this.$router.push({
			name: 'formulas.view',
			params: { formulaId: item.id },
		} as any);
	}

	public clickTable(item: Formula, newtab: boolean) {
		if (newtab) {
			const routeData = this.$router.resolve({
				name: 'formulas.view',
				params: { formulaId: item.id },
			} as any);
			window.open(routeData.href, '_blank');
		} else {
			this.$router.push({
				name: 'formulas.view',
				params: { formulaId: item.id },
			} as any);
		}
	}

	public async dataTableProvider(ctx: TableContext) {
		let data: any = [];
		try {
			const filters: FilterParam[] = this.filters.map((filter: DataTableFilter) => {
				return { field: filter.field, value: filter.value };
			});
			if (this.state.search) {
				filters.push({ field: 'name', value: this.state.search });
			}
			const response = await this.api.getFormulas(
				ApiUtils.queryOptions(filters, ctx, { params: {} }),
			);
			const body = response.data;

			data = body.data;
			this.state.totalRows = (body.meta && body.meta.total) || 0;
		} catch (e) {
			this.state.totalRows = 0;

			console.log(e);
			// throw e;
		}
		return data;
	}
}
